import { render, staticRenderFns } from "./New-message.vue?vue&type=template&id=5abd560e&scoped=true&lang=html"
import script from "./New-message.vue?vue&type=script&lang=js"
export * from "./New-message.vue?vue&type=script&lang=js"
import style0 from "./New-message.vue?vue&type=style&index=0&id=5abd560e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd560e",
  null
  
)

export default component.exports